import { useMutation, useQueryClient } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { UpdateFieldServiceCustomFieldsInput } from '@/gql/graphql';

const UPDATE_FIELD_SERVICE_CUSTOM_FIELDS = graphql(`
  mutation UpdateFieldServiceCustomFields(
    $input: UpdateFieldServiceCustomFieldsInput!
  ) {
    updateFieldServiceCustomFields(input: $input) {
      allowedSupplierIds
    }
  }
`);

const useUpdateFieldServiceCustomFields = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: UpdateFieldServiceCustomFieldsInput) => {
      return gqlClient.request(UPDATE_FIELD_SERVICE_CUSTOM_FIELDS, { input });
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.customFieldGroups(),
      });
    },
  });
};

export default useUpdateFieldServiceCustomFields;
